<form
  #f="ngForm"
  class="payment-options-component"
  (ngSubmit)="onSubmitPayment()"
>
  <div class="form-container">
    <div class="form-group">
      <label for="holder-name-payment">
        Nome que consta no cartão
      </label>

      <div>
        <input
          type="text"
          id="holder-name-payment"
          class="form-control text-uppercase placeholder-to-lowercase"
          placeholder=""
          name="holder_name"
          [(ngModel)]="creditcardData.holder_name"
          #holderName="ngModel"
          required
          minlength="3"
          [class.is-invalid]="holderName.invalid"
          [class.is-valid]="holderName.valid"
          (keyup)="partialData.emit(creditcardData)"
        />
      </div>

      <p class="form-text text-danger text-left" *ngIf="holderName.invalid">
        <small style="font-size: .6em">Nome que consta no cartão inválido.</small>
      </p>
    </div>

    <div class="form-group">
      <label for="card-number-payment">Número do cartão:</label>

      <div class="ccnumber__container">
        <input
          type="text"
          id="card-number-payment"
          class="form-control"
          placeholder="0000-0000-0000-0000"
          name="card_number"
          [(ngModel)]="creditcardData.card_number"
          required
          minlength="3"
          pattern="[0-9]+"
          #ccNumber="ngModel"
          #ccType="ccNumber"
          ccNumber
          cctypes="amex, visa, mastercard"
          mask="0000-0000-0000-0000"
          (keyup)="partialData.emit(creditcardData)"
        />

      </div>

      <p
        class="form-text text-danger text-left"
        *ngIf="ccNumber.invalid">
        <small style="font-size: .6em">Número de cartão de crédito inválido. </small>
      </p>
    </div>

    <div class="form-group">
      <div class="col-4">
        <label for="card-expiration-month-payment" class="">Data de expiração:</label>

        <div>
          <input
            ccExpiration
            #ccExpMonth="ngModel"
            ccExpRelated="ccExpYear"
            [(ngModel)]="creditcardData.exp_month"
            [class.is-invalid]="ccExpMonth.invalid"
            [class.is-valid]="ccExpMonth.valid"
            type="text"
            id="card-expiration-month-payment"
            class="form-control"
            placeholder="mm"
            name="exp_month"
            minlength="2"
            maxlength="2"
            required
            mask="00"
            (keyup)="partialData.emit(creditcardData)"
          />
        </div>

        <p class="form-text text-danger text-left"
          *ngIf="ccExpMonth.invalid">
          <small style="font-size: .6em"> Mês inválido. </small>
        </p>
      </div>

      <div class="col-4">
        <label
          *ngIf="ccExpMonth.valid"
          for="card-expire-year-payment" class="">&nbsp;</label>

        <div>
          <input
            ccExpiration
            #ccExpYear="ngModel"
            ccExpRelated="ccExpMonth"
            [(ngModel)]="creditcardData.exp_year"
            [class.is-invalid]="ccExpYear.invalid"
            [class.is-valid]="ccExpYear.valid"
            type="text"
            id="card-expire-year-payment"
            class="form-control"
            placeholder="aaaa"
            name="exp_year"
            minlength="4"
            maxlength="4"
            required
            mask="0000"
            (keyup)="partialData.emit(creditcardData)"
          />
        </div>

        <p class="form-text text-danger text-left"
          *ngIf="ccExpYear.invalid">
          <small style="font-size: .6em"> Ano inválido </small>
        </p>
      </div>
    </div>

    <div class="form-group">
      <div class="col-4">
        <label for="card-cvv-payment" class="">CVV:</label>

        <div>
          <input
            type="text"
            id="card-ccv-payment"
            class="form-control"
            placeholder="cvv"
            name="card_cvv"
            [(ngModel)]="creditcardData.card_cvv"
            required
            minlength="3"
            [disabled]="!ccNumber.value || (ccNumber.value && ccNumber.invalid)"
            [class.is-invalid]="ccCVC.invalid"
            [class.is-valid]="ccCVC.valid"
            #ccCVC="ngModel"
            ccType="ccType.value"
            ccCVC
            mask="0000"
            (keyup)="partialData.emit(creditcardData)"
          />
        </div>

        <p class="form-text text-danger text-left"
          *ngIf="ccCVC.invalid">
          <small style="font-size: .6em"> CVV do cartão inválido. </small>
        </p>
      </div>
    </div>

    <div class="form-group" style="height: 0;margin:0;">
      <button
        mat-button
        class="btn-payment-credit unh-button-old bleed-button"
        theme="pink-white"
        type="submit"
        id="btn-cartao-checkout"
        [disabled]="f.invalid || isSubmitting"
        (click)="onSubmit.emit(f.value)"
      >
        {{btn_text}}
        <unh-spinner-loader size="nano" *ngIf="isSubmitting">
        </unh-spinner-loader>
      </button>
    </div>


  </div>
</form>
